import { useSelector } from 'react-redux';
import { useConfig } from '@common/Hooks/useConfig';
import { ReactOnRailsRootComponent } from '@common/ReactOnRails';

const getDropdownFiltersOptions = (dropdownFilters, type) => {
    if (dropdownFilters[type]?.options) {
        return dropdownFilters[type].options;
    }

    return dropdownFilters[type];
};

export const FiltersListSeoBlock = ({
    filters,
    navigation
}) => {
    const config = useConfig();
    const dropdownFilters = useSelector(state => state.filters.dropdownFilters);
    const indexableFilters = dropdownFilters ? filters.reduce((draftOutput, filter) => {
        const { 'data-type': type } = filter;
        const filterOptions = getDropdownFiltersOptions(dropdownFilters, type);

        if (filterOptions && filterOptions.length > 0 && filterOptions[0].seoName) {
            draftOutput[type] = filterOptions;
        }

        return draftOutput;
    }, {}) : {};

    return Object.keys(indexableFilters).map(indexableFiltersGroup => (
        <nav
            key={indexableFiltersGroup}
            className="d-none"
        >
            {indexableFilters[indexableFiltersGroup].map(({ filterType, seoName, value }) => (
                <a
                    key={filterType + value}
                    href={`${config.URLPrefix}${navigation.url}_${filterType}=${value}`}
                    tabIndex="-1"
                >
                    {seoName}
                </a>
            ))}
        </nav>
    ));
};

export const FiltersListSeoBlockStandalone = ReactOnRailsRootComponent(FiltersListSeoBlock, { withReduxStore: true });
